import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static outlets = ["visible"]

  visibleOutletConnected() {
    this.updateCheckboxState()
  }

  async toggleAll(event) {
    const shouldCollapse = event.target.checked

    event.target.disabled = true
    this.isBulkUpdating = true

    for (const board of this.visibleOutlets) {
      await board.forceState(shouldCollapse)
    }

    this.isBulkUpdating = false
    event.target.disabled = false

    this.updateCheckboxState()
  }

  updateCheckboxState() {
    if (this.isBulkUpdating) return

    const checkbox = this.element.querySelector("input[type='checkbox']")
    if (!checkbox) return

    const hasExpanded = this.visibleOutlets.some(board => !board.isCollapsed())
    checkbox.checked = !hasExpanded
  }
}
